import { useTranslation } from "react-i18next";
import { CheckCircle2, Loader2, ScanFace, Sun, XCircle } from "lucide-react";

const STATE_ICON = { success: CheckCircle2, error: XCircle, verifying: Loader2 };

export const CaptureStatus = ({ phase, message, similarity, tooDark, tooBright, awsLiveness }) => {
  const { t } = useTranslation();
  const Icon = STATE_ICON[phase];

  return (
    <div className="mt-3 text-center" data-testid="face-capture-status">
      {tooDark || tooBright ? (
        <p
          data-testid="light-warning"
          className="mx-auto mb-2 flex w-fit items-center gap-2 rounded-full bg-amber-500/15 px-4 py-1.5 text-[11px] font-bold text-amber-400"
        >
          <Sun className="h-3.5 w-3.5" />
          {tooDark ? t("check.tooDark") : t("check.tooBright")}
        </p>
      ) : null}
      {Icon ? (
        <Icon
          className={`mx-auto h-6 w-6 ${
            phase === "success" ? "text-emerald-600" : phase === "error" ? "text-red-600" : "animate-spin text-primary"
          }`}
        />
      ) : (
        <ScanFace className="mx-auto h-6 w-6 text-slate-400" />
      )}
      <p className="mt-1.5 text-sm font-semibold">{message || t(awsLiveness ? "check.awsLivenessHint" : "check.livenessHint")}</p>
      {similarity ? (
        <p className="mt-1 font-mono text-xs text-primary" dir="ltr">
          {t("check.similarity")}: {similarity}%
        </p>
      ) : null}
    </div>
  );
};
